import { render } from "./all-payment-options.vue?vue&type=template&id=4b360676"
import script from "./all-payment-options.vue?vue&type=script&lang=js"
export * from "./all-payment-options.vue?vue&type=script&lang=js"
script.render = render

export default script